export default function getOrganizationUsersReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'GET_ORGANIZATION_USER_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'GET_ORGANIZATION_USER_ERROR':
            return {...state, ...{ error: action.error }};

        case 'GET_ORGANIZATION_USER_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}